<script setup>
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import BottomNavBar from "@/components/BottomNavBar"
import LoadingSpinner from "@/components/LoadingSpinner"
import {usePusherStore} from "@/stores/pusher.store";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/stores/user.store";

const route = useRoute();
const router = useRouter();

const title = computed(() => route.meta.title);
const showBackBar = computed(() => route.meta.showBackBar);
const showBottomBar = computed(() => route.meta.showBottomBar);

const handleBack = () => {
    router.back();
};


const userFromLocal = JSON.parse(localStorage.getItem('user'));
const pusherStore = usePusherStore();
const userStore = useUserStore();
const {user} = storeToRefs(userStore);
if (userFromLocal != null && userFromLocal.access_token != null) {
    userStore.fetchUser();
    pusherStore.subscribeToChannel('web-notification.' + userFromLocal.id);
    const {channel} = storeToRefs(pusherStore);
    channel.value.bind('web-notification-event', async function () {
        await userStore.fetchUser();
        console.log(user.value);
    });
}

</script>

<template>
    <van-config-provider theme="light">
        <van-nav-bar
            v-if="showBackBar"
            :title="title"
            left-text="Back"
            left-arrow
            fixed
            @click-left="handleBack"
        >
            <template #right>
                <van-icon v-if="route.name !== 'account'"
                          name="volume-o" size="18"
                          :badge="user.user_notification_count === 0 ? '' : user.user_notification_count"
                          @click="router.push('/notification/list')"/>
            </template>
        </van-nav-bar>
        <van-nav-bar
            v-else
            :title="title"
            fixed
        >
            <template #left>
                <van-image
                    round
                    width="5rem"
                    height="2rem"
                    src="/logo.png"
                    @click="router.push('/')"
                />
            </template>
            <template #right>
                <van-icon
                    v-if="route.name !== 'login' && route.name !== 'notificationList' && route.name !== 'registration'"
                    name="volume-o" size="18"
                    :badge="user.user_notification_count === 0 ? '' : user.user_notification_count"
                    @click="router.push('/notification/list')"/>
            </template>
        </van-nav-bar>
        <div style="margin-top: 50px;"/>
        <Suspense>
            <router-view/>
            <template #fallback>
                <div>Loading...</div>
            </template>
        </Suspense>
        <van-divider/>
        <van-row>&nbsp;</van-row>
        <van-back-top right="10vw" bottom="15vh"/>
        <BottomNavBar v-if="showBottomBar"/>
        <LoadingSpinner/>
    </van-config-provider>
</template>

<style>
:root:root {
    --van-cell-background: #eff2f5;
    --van-cell-value-color: #777;
}
.van-step__title {
    font-size: 10px !important;
}
.van-grid-item__icon {
    color: #1989fa
}
</style>
